import React, { useEffect, useState } from 'react';
import { History, X } from 'lucide-react';
import { getRecentlyViewed, clearRecentlyViewed, RECENT_EVENT, RECENT_LOCAL_EVENT, RECENT_CLEAR_EVENT } from '../../lib/recentlyViewed';
import { resolveImageUrl } from '../../lib/imageCache';

// Horizontal strip of the swatches the shopper enlarged most recently.
export const RecentlyViewedStrip = ({ onSelect, className = '' }) => {
  const [items, setItems] = useState(getRecentlyViewed);

  useEffect(() => {
    const sync = () => setItems(getRecentlyViewed());
    window.addEventListener(RECENT_EVENT, sync);
    window.addEventListener(RECENT_LOCAL_EVENT, sync);
    window.addEventListener(RECENT_CLEAR_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(RECENT_EVENT, sync); window.removeEventListener(RECENT_LOCAL_EVENT, sync); window.removeEventListener(RECENT_CLEAR_EVENT, sync); window.removeEventListener('storage', sync); };
  }, []);

  if (!items.length) return null;

  return (
    <div className={`rounded-xl border border-neutral-200 bg-white px-4 py-3 ${className}`} data-testid="recently-viewed-strip">
      <div className="flex items-center gap-2 mb-2">
        <History className="w-3.5 h-3.5 text-amber-600" />
        <span className="text-[11px] uppercase tracking-wider text-neutral-500 font-medium">Recently viewed</span>
        <span className="text-[11px] text-neutral-400" data-testid="recently-viewed-count">{items.length}</span>
        <button onClick={clearRecentlyViewed} className="ml-auto inline-flex items-center gap-1 text-[11px] text-neutral-400 hover:text-neutral-700" data-testid="recently-viewed-clear">
          <X className="w-3 h-3" /> Clear
        </button>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => onSelect(item)}
            title={`${item.name}${item.code ? ` · ${item.code}` : ''}`}
            className="group shrink-0 w-16 text-left"
            data-testid={`recently-viewed-${item.id}`}
          >
            <div className="w-16 h-16 rounded-lg overflow-hidden border border-neutral-200 group-hover:border-amber-500 group-hover:shadow-md transition-all bg-neutral-100">
              {item.image_url
                ? <img src={resolveImageUrl(item.image_url, 128)} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                : <div className="w-full h-full" style={{ backgroundColor: item.hex_color || '#ddd' }} />}
            </div>
            <p className="mt-1 text-[10px] text-neutral-700 truncate group-hover:text-amber-700">{item.name}</p>
            <p className="text-[9px] text-neutral-400 truncate">{item.collection_name}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewedStrip;
